import { render, staticRenderFns } from "./MembersTable.vue?vue&type=template&id=27607730&scoped=true"
import script from "./MembersTable.vue?vue&type=script&lang=js"
export * from "./MembersTable.vue?vue&type=script&lang=js"
import style0 from "./MembersTable.vue?vue&type=style&index=0&id=27607730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27607730",
  null
  
)

export default component.exports